import { inject, Injectable } from '@angular/core';
import { Subscription } from 'rxjs';
import { debounceTime, filter } from 'rxjs/operators';
import { deleteField, doc, docData, Firestore, updateDoc } from '@angular/fire/firestore';
import { ID_FIELD_OPTIONS, isDefined, USERS_COLLECTION } from '@damofire/data-commons';
import { AuthenticationService, User } from '@damofire/data-security';
import { Router } from '@angular/router';

@Injectable()
export class UserActionsService {
  private readonly firestore = inject(Firestore);
  private sub: Subscription;

  constructor(
    private readonly auth: AuthenticationService,
    private readonly router: Router,
  ) {
    this.auth.subscribe({
      next: (user: User) => this.observeActions(user),
    });
  }

  private observeActions(user: User): void {
    this.sub?.unsubscribe();
    if (user) {
      this.sub = docData<User>(doc(this.firestore, `${USERS_COLLECTION}/${user._id}`), ID_FIELD_OPTIONS)
        .pipe(
          filter((u) => isDefined(u?.forceAction)),
          debounceTime(1000),
        )
        .subscribe((u) => this.handleForceAction(u));
    }
  }

  private async handleForceAction(user: User): Promise<void> {
    console.log(`handleForceAction:`, user.forceAction, user._id);

    const userDoc = doc(this.firestore, `${USERS_COLLECTION}/${user._id}`);
    await updateDoc(userDoc, 'forceAction', deleteField());

    switch (user.forceAction) {
      case 'logout':
        this.auth.logout();
        break;
      case 'refresh':
        location.reload();
        break;
      case 'update':
        await this.router.navigateByUrl('/latest');
        break;
    }
  }
}
